const FeatureName = {
  MinorsOnCampusRegistrationForm: "Minors on Campus Program Registration Form",
  RCRAMinors: "RCRA Minors - Minor Form",
};

export default FeatureName;
